import { useQuery } from 'hooks/useCustomQuery';
import getVoicePolicies from 'API/VoicePolicies/getVoicePolicies';

const useGetVoicePolicies = () => {
    return useQuery({
        queryKey: ['VoicePolicies'],
        queryFn: getVoicePolicies,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
};

export default useGetVoicePolicies;
